import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
export const MEDICATION_SUSPEND_FIELD_REASON_VALIDATOR = 'medication-suspend-field-reason-validador';
export const MEDICATION_SUSPEND_FIELD_JUSTIFICATION_VALIDATOR = 'medication-suspend-field-justification-validador';
function requiredValidatorCreator(name, message) {
    return value => {
        if (!value) {
            return Promise.resolve([
                {
                    message: MessageService.translate(message),
                    name,
                    valid: false,
                },
            ]);
        }
        return Promise.resolve([
            {
                message: '',
                name,
                valid: true,
            },
        ]);
    };
}
export const medicationSuspendFieldReasonValidator = requiredValidatorCreator(MEDICATION_SUSPEND_FIELD_REASON_VALIDATOR, 'label.medication-suspend.reason-validator');
export const medicationSuspendFieldJustificationValidator = requiredValidatorCreator(MEDICATION_SUSPEND_FIELD_JUSTIFICATION_VALIDATOR, 'label.medication-suspend.justification-validation');
//# sourceMappingURL=suspend-medication-validators.js.map